<template>
  <div class="mailchimp-con">
    <iframe name="mcHiddenFrame" style="display: none;"></iframe>

    <form
      :action="mailchimpFormAction"
      method="post"
      target="mcHiddenFrame"
      novalidate
      class="input-group mb-3 footer-subscribe"
      @submit="handleSubmit"
    >
      <input
        type="email"
        name="EMAIL"
        class="form-control"
        placeholder="Enter your email address"
        aria-label="Enter your email address"
        required
        v-model="email"
      />

      <div class="input-group-append">
        <button
          class="button btn rounded-right rounded-left text-white text-uppercase btn-primary w-100"
          type="submit"
        >
          Sign up
        </button>

        <a
          :href="mailchimpUnsubscribeUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-link unsubscribe"
        >
          Unsubscribe
        </a>
      </div>

      <div style="position: absolute; left: -5000px;" aria-hidden="true">
        <input
          type="text"
          :name="honeypotFieldName"
          tabindex="-1"
          value=""
        />
        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px" aria-hidden="true">
          <input
            type="text"
            name="b_cfb875f333822581fa604182f_9d5fde54df"
            tabindex="-1"
            value=""
          />
        </div>
        <div class="input-group-append">
          <input
            type="submit"
            value="Sign up"
            name="subscribe"
            id="mc-embedded-subscribe"
            class="button btn rounded-right rounded-left text-white btn-primary w-100"
          />
        </div>
      </div>
    </form>

    <div
      v-show="showMessage"
      id="mc-msg"
      style="font-size: 0.85rem; margin-top: 0.5rem;"
    >
      <span v-if="alreadySubscribed">You are already subscribed to our newsletter.</span>
      <span v-else>Thank you for subscribing!</span>
    </div>
  </div>
</template>

<script>
import { $httpChangiRecommends } from '@/core/api';

export default {
  props: {
    mailchimpUserId: {
      type: String,
      default: null,
    },
    mailchimpAudienceId: {
      type: String,
      default: null,
    },
    defaultMailchimpUserId: {
      type: String,
      default: '',
    },
    defaultMailchimpAudienceId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showMessage: false,
      email: '',
      alreadySubscribed: false,
    };
  },
  computed: {
    resolvedUserId() {
      return this.mailchimpUserId || this.defaultMailchimpUserId;
    },
    resolvedAudienceId() {
      return this.mailchimpAudienceId || this.defaultMailchimpAudienceId;
    },
    mailchimpFormAction() {
      return `https://changirecommends.us11.list-manage.com/subscribe/post?u=${this.resolvedUserId}&id=${this.resolvedAudienceId}`;
    },
    mailchimpUnsubscribeUrl() {
      return `https://changirecommends.us11.list-manage.com/unsubscribe?u=${this.resolvedUserId}&id=${this.resolvedAudienceId}`;
    },
    honeypotFieldName() {
      return `b_${this.resolvedUserId}_${this.resolvedAudienceId}`;
    },
  },
  methods: {
    handleSubmit() {
      this.subscribeToNewsletter();
    },
    subscribeToNewsletter() {
      this.alreadySubscribed = false;
      $httpChangiRecommends.api
        .ChangiRecommendsNewsletterSubscribe({
          email: this.email,
          listId: this.resolvedAudienceId,
        })
        .then((response) => {
          this.email = '';
          console.log(response);
          this.showMessage = true;
          this.alreadySubscribed = response.data.already_subscribed;
        })
        .catch((error) => {
          console.error(error);
          this.alreadySubscribed = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.mailchimp-con {
  width: 100%;
}

.mailchimp-con .btn-primary {
  min-height: 38px;
  height: 38px;
}

.navbar-social .form-subs a.unsubscribe {
  color: #6c757d;
  margin-left: 1em !important;
}

.subscribe-desc-holder {
  display: inline-block;
  font-size: 0.8rem;
  position: absolute;
  left: 45px;
  top: -5px;
  text-align: left;
}

.subscribe-desc-holder b {
  font-size: 1.1rem;
}
</style>